"use strict";

import React, { createContext, useState } from "react";
import ECLToast from "../../eclComponents/Widgets/Toasts/ECLToast";

export const ToastContext = createContext();

export function ToastContextProvider(props) {
   const [toaster, setToaster] = useState([]);

   // addToast adds a new message to the front of the queue. null/undefined bodies are rejected
   const addToast = async (body, kind) => {
      if (body === null || body === undefined) {
         return null;
      }
      if (!kind || kind !== "error") {
         kind = "inform";
      }
      setToaster((prev) => [{ body, kind }, ...prev]);
   };

   //PopToast will optionally take an index, otherwise remove the first message from
   //the queue.  May be necessary in the future.
   const popToast = async (index) => {
      const outstandingToasts = [...toaster];
      index
         ? outstandingToasts.splice(index, 1)
         : outstandingToasts.splice(0, 1);
      setToaster(outstandingToasts);
   };

   return (
      <ToastContext.Provider value={addToast}>
         {props.children}
         {toaster.length > 0 ? (
            <ECLToast
               pop={popToast}
               toast={toaster[0]}
               multi={toaster.length > 1}
            ></ECLToast>
         ) : null}
      </ToastContext.Provider>
   );
}
